const getters = {
  auction_token: state => state.user.auction_token,
  userInfo: state => state.user.userInfo,
}
export default getters
